import React, { ReactNode } from 'react';
import { Link, mergeClasses } from '@fluentui/react-components';

import { useEmptyStateSizeContext } from '../contexts/size';
import { useEmptyStateActionStyles } from './empty-state-action-styles';

interface EmptyStateLinkProps {
  className?: string;
  children: ReactNode;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
}

export const EmptyStateLink = ({
  className,
  children,
  href,
  onClick,
}: EmptyStateLinkProps) => {
  const classes = useEmptyStateActionStyles();
  const { size } = useEmptyStateSizeContext();

  return (
    <Link
      className={mergeClasses(className, classes[size])}
      href={href}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
